function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask34",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 1,
  width: 25,
  height: 23
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,3 C3,2.73478351 3.10535684,2.4804296 3.29289322,2.29289322 C3.51247012,2.07331631 3.90748509,1.809973 4.50360932,1.57152331 C5.40642491,1.21039707 6.56360882,1 8,1 C9.41656341,1 10.3826299,1.27601899 12.3713907,2.07152331 C14.1326299,2.77601899 14.9165634,3 16,3 C17.1886088,3 18.0939249,2.83539707 18.7536093,2.57152331 C19.0949851,2.434973 19.2624701,2.32331631 19.2928932,2.29289322 C19.9228581,1.66292836 21,2.10909515 21,3 L21,15 C21,15.2652165 20.8946432,15.5195704 20.7071068,15.7071068 C20.4875299,15.9266837 20.0925149,16.190027 19.4963907,16.4284767 C18.5935751,16.7896029 17.4363912,17 16,17 C14.5834366,17 13.6173701,16.723981 11.6286093,15.9284767 C9.86737011,15.223981 9.08343659,15 8,15 C6.81139118,15 5.90607509,15.1646029 5.24639068,15.4284767 C5.15049861,15.4668335 5.06832724,15.5032261 4.99906031,15.5364058 L5,22 C5,22.5522847 4.55228475,23 4,23 C3.44771525,23 3,22.5522847 3,22 L3,22 L3,3 Z M8,3 C6.81139118,3 5.90607509,3.16460293 5.24639068,3.42847669 C5.15093187,3.46666021 5.06907007,3.50289723 5,3.53595588 L5,13.396437 C5.81910645,13.1433287 6.8144511,13 8,13 C9.41656341,13 10.3826299,13.276019 12.3713907,14.0715233 C14.1326299,14.776019 14.9165634,15 16,15 C17.1886088,15 18.0939249,14.8353971 18.7536093,14.5715233 C18.8490681,14.5333398 18.9309299,14.4971028 19,14.4640441 L19,4.603563 C18.1808935,4.85667129 17.1855489,5 16,5 C14.5834366,5 13.6173701,4.72398101 11.6286093,3.92847669 C9.86737011,3.22398101 9.08343659,3 8,3 Z",
  fill: "#000000",
  id: "icon"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "mask-icon",
  mask: "url(#mask34)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#000"
}));

var SvgOrganizations = function SvgOrganizations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganizations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/organizations.d7486307.svg";
export { ForwardRef as ReactComponent };